import { AccountCard } from "./account/AccountCard.connector";
import { RecentActivityCard } from "./activity/RecentActivityCard.connector";
import { AccountBalancesCard } from "./balances/AccountBalancesCard.connector";
import { CashCard } from "./cash/CashCard.connector";
import { MarketIndicesCard } from "./indices/MarketIndicesCard.connector";
import { OverviewPresentation } from "./Overview.pres";

/** Overview dashboard mount — wires cards into the layout presenter. */
export const Overview = () => (
  <OverviewPresentation
    account={<AccountCard />}
    cash={<CashCard />}
    balances={<AccountBalancesCard />}
    indices={<MarketIndicesCard />}
    activity={<RecentActivityCard />}
  />
);
